<div>
  <div class="modal-header super-compos-modal-header">
    <h4 class="modal-title super-compos-modal-title">
      <span class="noItalic super-compos-modal-title super-compos-modal-title-span">Déplacement des points</span>
    </h4>
    <div class="d-flex justify-content-end">
      <super-button styleClass="blue" (click)="ref.close(false);" [text]="'btn.cancel'|translate"></super-button>
      <super-button styleClass="green ms-3" text="Confirmer" [disabled]="!form.valid"
        (click)="confirm()"></super-button>
    </div>
  </div>

  <section [formGroup]="form" class="form">
    <div class="row align-items-end p-fluid">
      <div class="col-md-8">
        <label class="super-compos-label-input">Point</label>
        <p-dropdown [virtualScroll]="true" [itemSize]="30" formControlName="pointTarget" [options]="points"
          styleClass="w-100" [placeholder]="'Sélectionner un point'" appendTo="body" optionLabel="objetSynthese"
          [filter]="true">
          <ng-template let-item pTemplate="item">
            <div class="d-flex align-items-center">
              <div *ngIf="item.ordreReel">{{item.ordreReel + ' - '}}</div>
              <div>{{ item.objetSynthese }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="col-md-4 p-fluid">
        <p-selectButton [options]="positionTarget" formControlName="positionTarget" optionLabel="label"
          optionValue="value">
        </p-selectButton>
      </div>
    </div>
  </section>

  <div class="colorBackground">
    <div *ngIf="form.value.positionTarget === 'after' && form.value.pointTarget" class="card card__medium">
      <div class="d-flex w-100">
        <div class=" d-flex flex-column width">
          <span class="idPoint idPoint__small mb-2">{{form.value.pointTarget.id | hundredPoint}}</span>
          <span *ngIf="form.value.pointTarget.ordreReel" class="text-muted">Ordre:
            {{form.value.pointTarget.ordreReel}}</span>
        </div>
        <div class="">
          <span class="text-muted float">{{form.value.pointTarget.statusLabel}}</span>
          <div class="text__large">
            <div class="text-muted mb-2">{{form.value.pointTarget.matiere}}/{{form.value.pointTarget.serviceLabel}}
            </div>
            <span class="text__titre"
              [pTooltip]="form.value.pointTarget.objetSynthese.length > 95 ? form.value.pointTarget.objetSynthese : ''">{{form.value.pointTarget.objetSynthese}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center">
      <div *ngIf="form.value.pointTarget"><i
          [ngClass]="form.value.positionTarget === 'before' ? 'ms-5 bi bi-arrow-90deg-right' : 'ms-5 bi bi-arrow-return-right'"></i>
      </div>
      <div [ngClass]="form.value.pointTarget ? 'card card__small' : 'card card__large'">
        <span *ngFor="let p of pointSelected; let index = index;">
          <div class="d-flex align-items-center w-100">
            <div class="d-flex w-100">
              <div class="d-flex flex-column width">
                <span class="idPoint mb-2">{{p.id | hundredPoint}}</span>
                <span *ngIf="p.ordreReel" class="text-muted">Ordre: {{p.ordreReel}}</span>
              </div>
              <div>
                <span class="text-muted float">{{p.statusLabel}}</span>
                <div [ngClass]="form.value.pointTarget ? 'text__large' : 'text__small'">
                  <div class="text-muted mb-2">{{p.matiere}}/{{p.serviceLabel}}</div>
                  <span class="text__titre"
                    [pTooltip]="p.objetSynthese.length > 95 ? p.objetSynthese : ''">{{p.objetSynthese}}</span>
                </div>
              </div>
            </div>
          </div>
          <p-divider *ngIf="(pointSelected.length > 1) && ((index +1) !== pointSelected.length)"
            class="w-100"></p-divider>
        </span>
      </div>
    </div>

    <div *ngIf="form.value.positionTarget === 'before' && form.value.pointTarget" class="card card__medium">
      <div class="d-flex w-100">
        <div class=" d-flex flex-column width">
          <span class="idPoint idPoint__small mb-2">{{form.value.pointTarget.id | hundredPoint}}</span>
          <span *ngIf="form.value.pointTarget.ordreReel" class="text-muted">Ordre:
            {{form.value.pointTarget.ordreReel}}</span>
        </div>
        <div>
          <span class="text-muted float">{{form.value.pointTarget.statusLabel}}</span>
          <div class="text__large">
            <div class="text-muted mb-2">{{form.value.pointTarget.matiere}}/{{form.value.pointTarget.serviceLabel}}
            </div>
            <span class="text__titre"
              [pTooltip]="form.value.pointTarget.objetSynthese.length > 95 ? form.value.pointTarget.objetSynthese : ''">{{form.value.pointTarget.objetSynthese}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>